import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBCommodity {
  // DB获取商品列表、查询所需商品
  getDBGoods(options) {
    let url = `/api/goods/request/search?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取商品库存列表、查询所需商品库存
  getDBStockGoods(options) {
    let url = `/api/goods/request/search/num?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //各仓库详情
  getDBStockGoodsDetail(goodsId) {
    const url = `/api/goods/num/detail?goodsId=${goodsId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除商品
  getDBDeleteGoods(id) {
    const url = '/api/goods/delete?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB上架商品
  getDBUpGoods(id) {
    const url = '/api/goods/up/sale?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB下架商品
  getDBDownGoods(id) {
    const url = '/api/goods/down/sale?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品审核通过
  getDBAgreeGoods(id) {
    const url = '/api/goods/agree?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品审核拒绝
  getDBRejectGoods(id) {
    const url = '/api/goods/reject?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取商品详情
  getDBDetailGoods(id) {
    const url = '/api/goods/get?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取商品库存详情
  getDBDetailStockGoods(goodsId, warehouseId) {
    const url = `/api/goods/get/num?goodsId=${goodsId}&warehouseId=${warehouseId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB新增商品
  postDBAddGoods(data) {
    const url = '/api/goods/save'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改商品
  postDBUpdateCoods(data) {
    const url = '/api/goods/modify'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取规格信息
  getDBSpecification() {
    const url = '/api/specification/list'
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加规格
  postDBAddSpecification(name) {
    const url = '/api/specification/add'
    const data = {
      name
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加规格选项
  postDBAddSpecificationChild(optionName, specId) {
    const url = '/api/specification/add/option'
    const data = {
      optionName,
      specId
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品分类/商品分类数据获取
  getDBGoodsClassify(options) {
    let url = '/api/goods/goodscate/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品分类/添加商品分类
  postDBAddGoodsClassify(cateName, parentId) {
    const url = '/api/goods/goodscate/add'
    const data = {
      cateName,
      parentId
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品分类/删除商品分类
  postDBDeleteGoodsClassify(id) {
    const url = '/api/goods/goodscate/delete'
    const data = {
      id
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品分类/修改商品分类
  postDBUpdateGoodsClassify(id, cateName) {
    const url = '/api/goods/goodscate/update'
    const data = {
      id,
      cateName
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品分类/商品标签获取
  getDBLabel() {
    const url = '/api/goods/label/list'
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品分类/添加标签
  postDBUpdateLabel(data) {
    const url = '/api/goods/label/update'
    const datas = data
    return axios.post(url, datas).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB商品分类/删除标签
  postDBDeleteLabel(id) {
    const url = '/api/goods/label/delete'
    const data = {
      id
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取运费列表
  getFreightTplList(currentPage) {
    const url = `/api/traffic/cost/page?page=${currentPage}&size=10`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取运费列表
  getFreightAllList(currentPage) {
    const url = `/api/traffic/cost/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 新增运费模板
  addFreightTpl(data) {
    const url = `/api/traffic/cost/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据id获取运费模板详情
  getFreightTplInfoById(tplId) {
    const url = `/api/traffic/cost/get?id=${tplId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据id更新运费模板详情
  updateFreightTplInfo(data) {
    const url = `/api/traffic/cost/modify`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据id删除运费模板
  deleteFreightTplById(id) {
    const url = `/api/traffic/cost/delete?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //优惠券获取商品列表接口
  getAddGeneralGoodsList(options) {
    let url = `/api/goods/request/search/top/module?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //商品顶部导航添加商品
  getAddMallGeneralGoodsList(options) {
    let url = `/api/goods/request/search/top/module?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //促销商品获取列表
  getAddMallPromotionalGoodsList(options) {
    let url = `/api/goods/request/search/top/module?`
    let currOptions = Object.assign({}, options)
    currOptions.onPromotion = 1
    url += handleGetRequestParams(currOptions)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取普通商品列表
  getGeneralGoodsList(options) {
    let url = `/api/goods/request/search?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取促销商品列表
  getPromotionalGoodsList(options) {
    let url = `/api/goods/request/search?`
    let currOptions = Object.assign({}, options)
    currOptions.onPromotion = 1
    url += handleGetRequestParams(currOptions)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取商品列表--带规格
  getCommodityListWithNorm(options) {
    let url = '/api/goods/request/search/info?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取商品入库列表--带规格
  getCommodityListStorage(options) {
    let url = `/api/goods/request/search/storage/info?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取分页品牌
  getCommodityBrand(currentPage, content) {
    const url = `/api/brand/page?currentPage=${currentPage}&content=${content}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取所有品牌
  getCommodityAllBrand() {
    const url = `/api/brand/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 新增品牌
  postCommodityAddBrand(data) {
    const url = `/api/brand/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除品牌
  getCommodityDeleteBrand(id) {
    const url = `/api/brand/delete?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改品牌
  getCommodityUpdateBrand(data) {
    const url = `/api/brand/modify`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 按照条件查询所有商品(获取商品少量信息）
  getCommodityFewMessage(options) {
    let url = `/api/goods/request/search/few/message?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 商品列表批量操作
  postCommodityOperation(data) {
    const url = `/api/goods/deals`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除商品之前进行商品查询（判断是否是促销或套餐）
  postCommodityBeforeDelete(data) {
    const url = `/api/goods/exam/extra`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除规格
  getRemoveSpecification(id) {
    const url = `/api/specification/delete?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除规格属性
  getRemoveSpecificationOption(id) {
    const url = `/api/specification/delete/option?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //获取商品价格数据列表
  getGoodsPriceList(options) {
    let url = `/api/goods/price/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改价格
  postUpdatePrice(data) {
    const url = `/api/goods/batch/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改成本价
  postUpdateCostPrice(data) {
    const url = `/api/goods/basicPrice/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改等级价
  postUpdateLevelPrice(data) {
    const url = `/api/goods/levelPrice/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改客户指定价格
  postUpdateCusPrice(data) {
    const url = `/api/goods/update/cus/price`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //批量修改客户指定价格
  postBatchUpdateCusPrice(data) {
    const url = `/api/goods/batch/update/cus/price`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取参数数据
  getParamsList(searchValue, currentPage, groupId) {
    let url;
    if (groupId) {
      url = `/api/params/list?searchValue=${searchValue}&currentPage=${currentPage}&groupId=${groupId}`
    } else {
      // 默认参数组
      url = `/api/params/list?searchValue=${searchValue}&currentPage=${currentPage}`
    }
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 添加参数
  postAddParams(data) {
    const url = `/api/params/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除参数
  postDeleteParams(data) {
    const url = `/api/params/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改参数
  postUpdateParams(data) {
    const url = `/api/params/modify`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 自动补货
  postReplenishment(data) {
    const url = `/api/goods/add/sale/num`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //获取供应商列表
  getDBSupplierList() {
    const url = '/api/goods/supplier/list'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //分类管理权重排序
  postGoodscateWeight(data) {
    const url = `/api/goods/goodscate/weight/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 商品从属列表
  getGoodsSubordinationList(searchValue) {
    const url = `/api/goods/supplier/list?searchValue=${searchValue}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改商品从属(单个)
  postModifyGoodsSubordinationList(data) {
    const url = `/api/goods/modify/supplier`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //修改游客价增量
  postUpdateTouristPrice(itemId, visitorInc) {
    const url = `/api/goods/visitorInc/update?itemId=${itemId}&visitorInc=${visitorInc}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取参数组列表
  getParameterGroupList(groupName) {
    const url = `/api/params/group/list?groupName=${groupName}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 添加参数组
  postAddParameterGroup(data) {
    const url = `/api/params/group/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 往参数组添加参数名
  postAddParameterGroupName(data) {
    const url = `/api/params/group/add/params`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除参数组
  postDeleteParameterGroup(data) {
    const url = `/api/params/group/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 移除参数
  postRemoveParameter(data) {
    const url = `/api/params/group/del/params`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 根据skuid更新商品
  postUpdateSkuIdGoodsInfo(itemId) {
    const url = `/api/goods/item/get?itemId=${itemId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 参数值拖动排序
  postDropParameter(data) {
    const url = `/api/params/sort/value`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取参数值
  getDropAfterParameterList(paramsId) {
    const url = `/api/params/value/list?paramsId=${paramsId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 商品分类游客可见开关
  postChangeTourists(data) {
    const url = `/api/goods/goodscate/visitorVisible/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 查看商品正在进行的活动
  getLookActivity(goodsId, itemId) {
    const url = `/api/db/activity/sku/promotion?goodsId=${goodsId}&itemId=${itemId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 操作日志
  getOperatorLog(goodsId, pageNo) {
    const url = `/api/goods/operate/history/list?goodsId=${goodsId}&pageNo=${pageNo}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 商品价格操作日志（skuid）
  getSkuIdOperatorLog(itemId, pageNo) {
    const url = `/api/goods/sku/operate/history/list?itemId=${itemId}&pageNo=${pageNo}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改参数组名称
  postModifyParameterGroupName(data) {
    const url = `/api/params/groupName/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改参数名
  postModifyParameterName(data) {
    const url = `/api/params/modify/value`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改参数时详情页的接口
  getModifyParameterNameId(paramId) {
    const url = `/api/params/get/param/info?paramId=${paramId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 查看sku具体仓库的库存信息
  getSkuWarehouse(itemId, warehouseId) {
    const url = `/api/goods/sku/num?itemId=${itemId}&warehouseId=${warehouseId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改sku具体库存信息
  postModifySkuWarehouse(data) {
    const url = `/api/goods/sku/num/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改db供应商商品价格页面的可售库存
  postModifySaleNum(data) {
    const url = `/api/goods/sku/num/update/without/warehouse`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBCommodity
